import {SimplePresentation} from "./SimplePresentationRunner";
import {Possessed} from "../../Possessed";
import {PossessedGameMode} from "../../server/PossessedGameMode";
import {gsap} from "gsap";
import {PossessedWinConfig} from "../../config/PossessedWinConfig";

export class FreespinsOutroPresentation extends SimplePresentation {


    constructor() {
        super("FreespinsOutroPresentation");
    }

    shouldRun(): boolean {
        return Possessed.model.isLastFreespin() && !Possessed.model.gameData.brokeTheBank;
    }

    buildTimeline() {
        const tl = this.tl;
        tl.eventCallback("onComplete", () => {this.controller.setSkipCallback()});

        const outroLoop = Possessed.model.data.freeSpinType == 5 ? "sfsOutroLoop" : "fsOutroLoop";

        //Freespin outro
        tl.add(()=> Possessed.keypadPlugin.setZeroBetSpinCounter(-1));
        tl.add(Possessed.transitionScreen.showFreespinsOutro(), "<");
        tl.add(() => {
            Possessed.soundPlayer.fadeOutMusic(100);
            Possessed.soundPlayer.playLoopingSound(outroLoop, 1, 0, 100);
        })

        const outroSound = Possessed.model.getBetPrice() < Possessed.model.data.accumulatedRoundWin ? "fsOutroStartGood" : "fsOutroStartBad";

        if(Possessed.model.isWinBelowStake() == false) {
            tl.add(()=> {
                Possessed.soundPlayer.playSound(outroSound);
            }, "<");
        }

        // Reset mystery reels in case they are full cross variants.
        tl.add(() => {
            Possessed.reelView.reelCross.getAllMysteryReels().forEach(reel => reel.isFullCross = false);
        })

        if(!Possessed.model.gameData.brokeTheBank) {
            tl.add(Possessed.transitionScreen.enableButton(() => {this.onButtonClick(outroSound)}))
        } else {
            tl.add(() => this.controller.finish(), ">1");
            tl.add(Possessed.transitionScreen.instantHideIntroOutro());
        }
    }

    private onButtonClick(outroSound:string) {
        const outroLoop = Possessed.model.data.freeSpinType == 5 ? "sfsOutroLoop" : "fsOutroLoop";
        const tl = gsap.timeline()
            .add(() => {
                Possessed.keypadPlugin.show();
                Possessed.soundPlayer.stopSound(outroLoop, 100);
                Possessed.soundPlayer.switchMusic(PossessedGameMode.NORMAL);
                Possessed.soundPlayer.playSound("fsOutroEnd");
            })
        if(Possessed.model.isWinBelowStake() == false) {
            tl.add(()=> {Possessed.soundPlayer.stopSound(outroSound, 200)});
        }
        tl.add(Possessed.transitionScreen.hideIntroOutro(), "<")
        tl.add(() => {
            const isXbet:boolean = Possessed.xbetEnabled;
            Possessed.backgroundElements.setMode(isXbet ? "XBET" : PossessedGameMode.NORMAL);
            Possessed.reelView.reelCross.updateCross(isXbet ? "XBET" : PossessedGameMode.NORMAL);
        }, "<")
        tl.add(() => {Possessed.foregroundElements.setBaseLogo()}, "<");
        tl.add(() => this.controller.finish());
        //tl.add(Possessed.xBetView.show());
    }
}
